<script>
import {userMixin} from "@/mixin";
import {email, maxLength, minLength, numeric, required, requiredIf, sameAs} from "vuelidate/lib/validators";
import profileForm from "@/components/app/profile/profileInfoForms/mixin/profileForm";
import FileInput from "@/components/app/profile/components/FileInput.vue";

export default {
    name: "personalDocumentForm",
    mixins: [userMixin, profileForm],
    components: {FileInput},
    validations: {
        user: {
            contractNumber: {
                // required: requiredIf(function (nestedModel) {
                //     return this.user.recipientTypeId != 0
                // }),
                minLength: minLength(2)
            },
            nbuNumber: {
                // required: requiredIf(function (nestedModel) {
                //     return this.user.recipientTypeId != 0
                // }),
                minLength: minLength(8),
                //maxLength: maxLength(8)
            },
            nbuId: {
                // required: requiredIf(function (nestedModel) {
                //     return this.user.recipientTypeId != 0
                // }),
                minLength: minLength(10),
                maxLength: maxLength(16)
            },
        }
    },
    methods: {
    }
}
</script>

<template>
    <div class="user-section">
        <div class="row">
            <div class="col-12 user-section-header">
                <h4 class="text-left font-weight-bold">Документи:</h4>
                <hr/>
            </div>
            <div v-if="!isRecipientFizType() || isRecipientFizReferalType()" class="col-lg-4">
                <div class="form-group">
                    <div class="field-label">Номер договору</div>
                    <input v-if="!skeletonOff" v-model.trim="user.contractNumber" type="text"
                           placeholder="Номер договору" class="form-control"
                           :class="['form-control', {invalid: ($v.user.contractNumber.$error)}]"
                    >
                    <PuSkeleton class="skeleton-input" v-else/>
                    <small class="error" v-if="$v.user.contractNumber.$dirty && !$v.user.contractNumber.minLength">Введіть номер договору</small>
<!--                    <small class="error" v-if="$v.user.contractNumber.$dirty && !$v.user.contractNumber.required">Введіть номер договору</small>-->
                </div>
            </div>

            <div v-if="!isRecipientFizType() || isRecipientFizReferalType()" class="col-lg-4">
                <div class="form-group">
                    <div class="field-label">Номер в реєстрі НБУ</div>
                    <input v-if="!skeletonOff" v-mask="'##########'" v-model.trim="user.nbuNumber" type="text"
                           placeholder="Номер в реєстрі НБУ" class="form-control"
                           :class="['form-control', {invalid: ($v.user.nbuNumber.$error)}]">
                    <PuSkeleton class="skeleton-input" v-else/>
                    <small class="error" v-if="$v.user.nbuNumber.$dirty && !$v.user.nbuNumber.minLength">Введіть номер в реєстрі НБУ</small>
<!--                    <small class="error" v-if="$v.user.nbuNumber.$dirty && !$v.user.nbuNumber.required">Введіть номер в реєстрі НБУ</small>-->
                </div>
            </div>

            <div v-if="!isRecipientFizType() || isRecipientFizReferalType()"  class="col-lg-4">
                <div class="form-group">
                    <div class="field-label">ID в реєстрі НБУ</div>
                    <input autocomplete="new-password" v-if="!skeletonOff" v-model.trim="user.nbuId" type="text"
                           placeholder="ID в реєстрі НБУ " class="form-control"
                           :class="['form-control', {invalid: ($v.user.nbuId.$error)}]">
                    <PuSkeleton class="skeleton-input" v-else/>
                    <small class="error" v-if="$v.user.nbuId.$dirty && !$v.user.nbuId.minLength">Введіть ID в реєстрі НБУ</small>
<!--                    <small class="error" v-if="$v.user.nbuId.$dirty && !$v.user.nbuId.required">Введіть ID в реєстрі НБУ</small>-->
                </div>
            </div>

            <div v-if="!isRecipientFizType() || isRecipientFizReferalType()"  class="col-lg-4 field-document-wrap">
                <div class="form-group">
                    <file-input ref="contractFileInput" v-if="!skeletonOff" v-model="user.contractPath"
                                :title="'Завантажити Договір'" :titleShow="'Переглянути Договір'"></file-input>
                </div>
            </div>
            <div class="col-lg-4 field-document-wrap">
                <div class="form-group">
                    <file-input ref="passportFileInput" v-if="!skeletonOff" v-model="user.passportPath"
                                :title="'Завантажити копію Паспорта'" :titleShow="'Переглянути копію Паспорта'"></file-input>
                </div>
            </div>
            <div class="col-lg-4 field-document-wrap">
                <div class="form-group">
                    <file-input ref="passportFileInput" v-if="!skeletonOff" v-model="user.ipnPath"
                                :title="'Завантажити ІПН'" :titleShow="'Переглянути ІПН'"></file-input>
                </div>
            </div>
            <div v-if="!isRecipientFizType() || isRecipientFizReferalType()"  class="col-lg-4 field-document-wrap">
                <div class="form-group">
                    <file-input ref="passportFileInput" v-if="!skeletonOff" v-model="user.edrExtractPath"
                                :title="'Завантажити Витяг з ЄДР'" :titleShow="'Переглянути Витяг з ЄДР'"></file-input>
                </div>
            </div>
            <div v-if="!isRecipientFizType() || isRecipientFizReferalType()" class="col-lg-4 field-document-wrap">
                <div class="form-group">
                    <file-input ref="passportFileInput" v-if="!skeletonOff" v-model="user.accountCertificatePath"
                                :title="'Переглянути Довідку про рахунок'" :titleShow="'Переглянути Довідку про рахунок'"></file-input>
                </div>
            </div>
            <div class="col-lg-4 field-document-wrap">
                <div class="form-group">
                    <file-input ref="passportFileInput" v-if="!skeletonOff" v-model="user.placeResidencePath"
                                :title="'Завантажити Витяг про місце проживання '" :titleShow="'Переглянути Витяг про місце проживання '"></file-input>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>

</style>
